"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CloseButton", {
    enumerable: true,
    get: function() {
        return CloseButton;
    }
});
var _themetools = require("@chakra-ui/theme-tools");
var baseStyle = {
    backgroundColor: "transparent",
    borderRadius: "0.375rem",
    color: "text-primary",
    _hover: {
        backgroundColor: (0, _themetools.transparentize)("background-action-hover", 0.15)
    },
    _active: {
        backgroundColor: (0, _themetools.transparentize)("background-action-pressed", 0.2)
    },
    _focus: {
        boxShadow: "0 0 0 0.1875rem var(--chakra-colors-primary-focus)"
    }
};
var CloseButton = {
    baseStyle: baseStyle,
    sizes: {
        s: {
            height: "1.5rem",
            width: "1.5rem"
        },
        m: {
            height: "2rem",
            width: "2rem"
        },
        l: {
            height: "2.5rem",
            width: "2.5rem"
        }
    },
    defaultProps: {
        size: "l"
    }
};
